module.exports = __webpack_public_path__ + "static/media/sample-chinese-resident-card-back.bdf94eef.png";